<template>
  <v-dialog v-model="showModal" persistent max-width="700px">
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Keitimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12" class="mb-3" v-html="confirmText"></v-col>
              <v-col cols="12">
                <el-textarea
                  required
                  :label="priezastisLabel"
                  counter="1500"
                  v-model="priezastis"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button primary @click.native="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPasTvarkymas',
  props: {
    item: Object,
    value: Boolean,
  },
  data() {
    return {
      priezastis: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    confirmText() {
      if (!this.item) {
        return null
      }
      return `Ar tikrai norite programoje TURTAS paslaugos
                          <b>${this.item.turtas_tipas_pav} Nr. ${
        this.item.turtas_nr
      }</b>
                          būseną keisti į "${
                            this.item.turtas_tipas === 'prasymas'
                              ? 'Nutrauktas'
                              : 'Atmestas'
                          }"? `
    },
    priezastisLabel() {
      if (!this.item) {
        return null
      }
      return `${
        this.item.turtas_tipas === 'prasymas'
          ? 'Nutraukimo priežastis'
          : 'Atmetimo priežastis'
      }`
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.priezastis = `${
          this.item.turtas_tipas === 'prasymas'
            ? 'Prašymas įvykdytas kitais kanalais.'
            : 'Paieška įvykdyta kitais kanalais.'
        }`
      }
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('confirm', this.item, this.priezastis)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.$emit('cancel')
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
